import Vue from 'vue'
import Router from 'vue-router'

/** 门店主页*/
import Index from '@/components/Index'
import Home from '@/components/Home'
import SearchStore from '@/components/SearchStore'
import Evaluate from '@/components/Evaluate'
import station from '@/components/Station'

/** 苏宁广场*/
import Order from '@/components/Order'
import Qrcode from '@/components/Qrcode'
import Product from '@/components/Product'
import ProductRule from '@/components/ProductRule'

/** 领券*/
import Ticket from '@/components/Ticket'

/** 红孩子母婴*/
import Vip from '@/components/Vip'
import Error from '@/components/Error'

/**电器城**/
import StorePage from '@/components/StorePage'

/**商品参数页**/
import ProductInfo from '@/components/ProductInfo'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/index/:storeCode',
      name: 'Index',
      component: Index
    },
    {
      path: '/order/:storeCode',
      name: 'Order',
      component: Order
    },
    {
      path: '/qrcode',
      name: 'Qrcode',
      component: Qrcode
    },
    {
      path: '/product/:commonId/:commonNo',
      name: 'Product',
      component: Product
    },
    {
      path: '/product_rule/:goodsCode',
      name: 'ProductRule',
      component: ProductRule
    },
    {
      path: '/vip/:storeCode',
      name: 'Vip',
      component: Vip
    }, {
      path: '/error',
      name: 'Error',
      component: Error
    },
    {
      path: '/ticket/:cityCode/:storeCode/:guideId',
      name: 'Ticket',
      component: Ticket
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },{
      path: '/storepage/:storeType/:storeCode/:cityCode',
      name: 'StorePage',
      component: StorePage
    },
    {
      path: '/SearchStore/:cityCode',
      name: 'SearchStore',
      component: SearchStore
    },
    {
      path: '/Evaluate/:storeCode',
      name: 'Evaluate',
      component: Evaluate
    },
    {
      path: '/productinfo/:prdCode',
      name: 'ProductInfo',
      component: ProductInfo
    },
    {
      path: '/station/:cityCode/:storeCode',
      name: 'station',
      component: station
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js